import { useState } from 'react'
import isEqual from 'lodash-es/isEqual'

import { getPermanentFilters as getPermanentFiltersCommon } from '../../../../utils/filter'

export function useTableReloadAfterMassAction({
  filterValues,
  getPermanentFilters = getPermanentFiltersCommon,
  sub,
  onReload,
}) {
  const [shouldReloadFilters, setShouldReloadFilters] = useState(false)

  function handleReloadTableAfterMassAction() {
    if (isEqual(filterValues, getPermanentFilters({ filterValues, sub }))) {
      return onReload()
    }

    return new Promise(resolve => {
      return resolve(setShouldReloadFilters(true))
    })
  }

  return {
    handleChangeShouldReloadFilters: setShouldReloadFilters,
    handleReloadTableAfterMassAction,
    shouldReloadFilters,
  }
}
